var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"c25a0bfd4274ee8627d0bf7bc9498a51e86cd46d"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'
import { isLocal, isProduction } from './src/utils/environment'

const packageInfo = require('./package.json')
const tagCommit = process.env.CI_COMMIT_TAG
const envStage = process.env.NEXT_PUBLIC_ENV
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

const sentryRelease = `${tagCommit ? `${tagCommit}-` : ``}${envStage}-${packageInfo.version}`

const tracesSampleRateAmount = isProduction ? 0.1 : 0

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: !isLocal,
  environment: process.env.NEXT_PUBLIC_ENV,
  tracesSampleRate: tracesSampleRateAmount,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.2,
  //release: `${sentryRelease}`,
  integrations: [
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
  ],
  ignoreErrors: [
    'Error: Attempt to connect to relay via `transportOpen` has stalled. Retrying...',
    'TypeError: NetworkError when attempting to fetch resource.',
    'TypeError: отменено',
    'Error: websocket error 1006:',
    'TypeError: Load failed',
    'TypeError: vazgeçildi',
    'NetworkError',
    'Socket stalled when trying to connect to wss://relay.walletconnect.org',
  ],
  denyUrls: [
    /events\.launchdarkly\.com/i,
    /app\.launchdarkly\.com/i,
    /.*launchdarkly\.com/i,
    /https:\/\/events\.launchdarkly\.com/i,
    /https:\/\/app\.launchdarkly\.com/i,
    /https:\/\/.*launchdarkly\.com/i,
  ],
})
